import { circleInfo, tick } from "@simplybusiness/icons";
import { Flex, Icon, Text } from "@simplybusiness/mobius";
import type { Cover as CoverType, HelpText } from "../../../types";
import { CoverLimit } from "../../CoverLimit";
import {
  formatAmount,
  isAdditionalInsured,
  findHelpText,
} from "../transformCoverage";

type DisplayVariant = "qcp" | "qds";

type ExtraCoverageProps = {
  extraCovers: CoverType[] | undefined;
  parentCover?: string;
  variant: DisplayVariant;
  helpText?: HelpText[];
};

export const ExtraCoverage = ({
  extraCovers,
  parentCover,
  variant,
  helpText,
}: ExtraCoverageProps) => {
  return (
    extraCovers && (
      <Flex flexDirection="column">
        {extraCovers
          .filter(cover => cover.parentCover == parentCover)
          .map(cover => (
            <div key={cover.coverName}>
              <Flex
                flexGrow={1}
                alignItems="center"
                className="mobius-quote-card__extra-coverage-item"
              >
                <Icon
                  className="mobius-quote-card__coverage-tick-icon"
                  icon={tick}
                />
                <CoverLimit
                  title={
                    isAdditionalInsured(cover)
                      ? "Additional Insured"
                      : cover.displayName
                  }
                  amount={
                    isAdditionalInsured(cover)
                      ? "Included"
                      : formatAmount(cover.displayLimit)
                  }
                  explainer={
                    helpText && findHelpText(helpText, cover.displayName)
                  }
                  withModal
                />
              </Flex>
              {variant == "qds" && isAdditionalInsured(cover) && (
                <AdditionalInsureds />
              )}
            </div>
          ))}
      </Flex>
    )
  );
};

const AdditionalInsureds = () => (
  <Flex
    alignItems="center"
    gap="sm"
    flexGrow={1}
    className="mobius-quote-card__additional-insureds"
  >
    <div role="img" aria-label="information icon">
      <Icon
        icon={circleInfo}
        color="var(--color-neutral-700)"
        size="md"
        fixedWidth
      />
    </div>
    <Text spacing="loose" variant="small">
      Additional insured details can be added after purchase
    </Text>
  </Flex>
);
